const { GoogleAnalyticsId } = require('../../services').Configuration;
const { isLocal } = require('../../config');


var Tracker = function() {
	this.track = function(event, details) {
		gtag('event', event, details);
	};

	this.trackPageview = function() {
		// Theoretically a no-op for GA4.
		// https://support.google.com/analytics/answer/11403294?hl=en
	};

	this.trackEvent = function(category, action, label, value) {
		this.track('event', {
			category,
			action,
			label,
			value
		});
	};

	this.trackBeginCheckout = function(vendor, cards) {
		const baseValue = cards.reduce((cartTotal, card) => {
			cartTotal += card.price * card.quantity
		}, 0);

		const expectedConversionRate = 0.1;
		const commissionRate = 0.035;
		const value =
			baseValue
			* commissionRate
			* expectedConversionRate
		;

		gtag('event', 'begin_checkout', {
			currency: 'USD',
			value,
			items: cards.map(c => ({
				item_id: c.name,
				item_name: c.name,
				affiliation: vendor,
				price: c.price,
				quantity: c.quantity
			}))
		});
	}
};


const tag = document.createElement('script');
tag.src = `https://www.googletagmanager.com/gtag/js?id=${GoogleAnalyticsId}`;
tag.async = true;
document.body.appendChild(tag);

window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function() {
	dataLayer.push(arguments);
}
gtag('js', new Date());
gtag('config', GoogleAnalyticsId, isLocal ? { debug_mode: true } : {});

module.exports = Tracker;
